var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "content-none", attrs: { id: _vm.name } }, [
    _vm.isEditor
      ? _c(
          "div",
          { staticClass: "content-none-placeholder" },
          [
            _c(
              "div",
              { staticClass: "title" },
              [
                _vm._v(_vm._s(_vm.name) + "\n      "),
                _vm.filestore
                  ? [
                      _vm._v(
                        "\n      | File Store: " +
                          _vm._s(_vm.filestore.filestoreID) +
                          "\n      "
                      ),
                    ]
                  : _vm._e(),
              ],
              2
            ),
            _vm._v(" "),
            _vm.widgetType === "none"
              ? [
                  _c("p", { staticClass: "hint" }, [
                    _vm._v(
                      "\n        Please activate the\n        Content Creator\n        to add content.\n      "
                    ),
                  ]),
                ]
              : [
                  _c("p", { staticClass: "hint" }, [
                    _vm._v(
                      "\n        The " +
                        _vm._s(_vm.widgetType) +
                        " layout selected has misconfigured settings and will not be displayed.\n      "
                    ),
                  ]),
                ],
          ],
          2
        )
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }